import { IState } from '../../../store';

export function isFromBuilderSelector(state: IState) {
  const { offer } = state.offerData;

  return (
    offer.isFromBuilder ||
    (offer.newbuilding && (offer.newbuilding.isFromDeveloper || offer.newbuilding.isFromLeadFactory))
  );
}
